export default "__VITE_ASSET__CKSiTL9V__"